import { memo } from 'react';

import styles from './BottomLiquidGlassEffect.module.scss';

const BottomLiquidGlassEffect = () => {
  return <div className={styles.blurLayer} />;
};

export default memo(BottomLiquidGlassEffect);
